import React from "react";
import { Link } from "react-router-dom";
import hshape from "../../assets/img/hshape.svg";
import BlogCard from "./BlogCard";
const handleClick = (text) => {
    localStorage.setItem("categoryName", text);
  };
const DownloadSection = () => {
    return (
        <section className="section-space">
            <div className="container-xl">
            <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="main-h">
                            <h2 className="m-heading">Healthy News and Views</h2>
                            <img src={hshape} className='img-fluid ' alt="logo" />
                        </div>
                    </div>
                </div>
                <div className="row">
                 
                        <BlogCard />
                   </div>
                <div className="text-center">
                   
					 <Link to={`/blogs`} className="btn btn-white mr-top" onClick={() => handleClick('blogs')}>View All</Link>
                </div>
            </div>
        </section>
    );
};

export default DownloadSection;